import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pdf-find-next',
  templateUrl: './pdf-find-next.component.html',
  styleUrls: ['./pdf-find-next.component.css']
})
export class PdfFindNextComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
